export enum GraphTimeUnits {
	Seconds,
	Minutes,
	Hours,
	Days,
}
